export const LOAD_COMPLIANCE = 'LOAD_COMPLIANCE'
export const UPDATE_CONTROL_STATUS = 'LOAD_COMPLIANCE_STATUS'
export const LOAD_FRAMEWORKS = 'LOAD_FRAMEWORKS'
export const LOAD_CONTROLS = 'LOAD_CONTROLS'
export const ADD_COMMENT = 'ADD_COMMENT'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const LOAD_ACTIVITY = 'load_activity'
export const ADD_ACTIVITY = 'add_activity'
export const SET_LOADING_STATE = 'SET_LOADING_STATE'
export const LOAD_ENABLED_FRAMEWORKS = 'LOAD_ENABLED_FRAMEWORKS'
export const LOAD_SUMMARY = 'LOAD_SUMMARY'
export const LOAD_USERS = 'LOAD_USERS'

export function loadActivity () {
  return {
    type: LOAD_ACTIVITY,
    activities: []
  }
}

export function setLoadingState (state = true) {
  return {
    type: SET_LOADING_STATE,
    payload: state
  }
}

export function addActivity (activities, id) {
  return {
    type: ADD_ACTIVITY,
    activities
  }
}

export function loadControls (controls) {
  return {
    type: LOAD_CONTROLS,
    payload: controls
  }
}

export function loadCompliance (controls) {
  return {
    type: LOAD_COMPLIANCE,
    controls
  }
}

export function updateControlStatus (controlId, status) {
  return {
    type: UPDATE_CONTROL_STATUS,
    payload: { controlId, status }
  }
}

export function loadSummary (summary) {
  const _summary = Object.assign(
    {},
    summary,
    {
      controlSummary: {
        applicableControls: 
        summary.controlSummary.totalEnabledControls -
          summary.controlSummary.numControlsNotApplicable,
        ...summary.controlSummary
      }
    })

  return {
    type: LOAD_SUMMARY,
    payload: _summary
  }
}

export function loadUsers (users) {
  return {
    type: LOAD_USERS,
    payload: users
  }
}

export function loadFrameworks (frameworks) {
  return {
    type: LOAD_FRAMEWORKS,
    payload: frameworks
  }
}

export function loadEnabledFrameworks (frameworks) {
  return {
    type: LOAD_ENABLED_FRAMEWORKS,
    payload: frameworks
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/complianceActions.js